<script>
    import TheSvgIcon from "@main/packages/TheSvgIcon";

    export default {
        name: "MobileTabs",
        components: { TheSvgIcon },
        props: {
            maxLength: {
                type: Number,
                default: 2,
            },
        },
        data() {
            return {
                selectedIndex: 0,
            };
        },
        methods: {
            onChange(direction) {
                if (direction === "prev") {
                    this.selectedIndex > 0 ? this.selectedIndex-- : (this.selectedIndex = 0);
                }
                if (direction === "next") {
                    this.selectedIndex < this.maxLength - 1
                        ? this.selectedIndex++
                        : (this.selectedIndex = this.maxLength - 1);
                }
                this.$emit("on-change", this.selectedIndex);
            },
        },
    };
</script>

<template>
    <div class="mobile-tabs">
        <button
            class="mobile-tabs__control is-left"
            :disabled="selectedIndex === 0"
            @click="onChange('prev')"
        >
            <the-svg-icon name="arrow" :size-w="24"></the-svg-icon>
        </button>

        <div class="mobile-tabs__text">
            <slot></slot>
        </div>

        <button
            class="mobile-tabs__control is-right"
            :disabled="selectedIndex === maxLength - 1"
            @click="onChange('next')"
        >
            <the-svg-icon name="arrow" :size-w="24"></the-svg-icon>
        </button>
    </div>
</template>

<style lang="scss">
    .mobile-tabs {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .mobile-tabs__control {
        position: relative;
        @include box(24px);
        -webkit-tap-highlight-color: transparent;
        svg {
            transition: opacity 0.2s ease-in;
            fill: var(--slider-arrow-store);
        }
        &::before {
            content: "";
            @include center-absolute(-8px);
        }
        &:disabled {
            pointer-events: none;
            svg {
                opacity: 0.3;
            }
        }
        &.is-right {
            transform: scale(-1);
        }
    }
</style>
